//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, pickerOption } from "@/mixins/index";
export default {
  name: "downloadInterview",
  mixins: [loadMoreList, pickerOption],
  data: function data() {
    return {
      pagingReqFn: "gameList",
      pagingReqValue: "list",
      value2: []
    };
  },
  mounted: function mounted() {},
  activated: function activated() {
    this.getList();
  },
  methods: {}
};